import React from "react";
import { withStyles } from "@mui/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTint  } from '@fortawesome/free-solid-svg-icons';
// import Battery60RoundedIcon from '@mui/icons-material/Battery60Rounded';

const styles = {
    outerDiv: () => ({
      display: "flex",
      height: "100%",
      width: "100%",
    }),
    modularDiv: (props) => ({
      display: "flex",
      borderRight: `1px solid ${props.borderColor}`,
      alignItems: "center",
      fontSize: props.fontSize,
      // width: (props.width),
      borderLeft: `1px solid ${props.borderColor}`,
      width: "75px",
    }),
    icon: (props) => ({
      maxHeight: "3.5em",
      paddingLeft: "0.8em",
      fontSize: props.fontSize,
    }),
    text: (props) => ({
      margin: "0px",
      fontFamily: "Montserrat",
      fontSize: props.fontSize,
      color: props.textColor,
      marginLeft:'5px'
    }),
    noViolationsDiv: {
      display: "flex",
      // justifyContent: 'center',
      alignItems: "center",
      height: "auto",
      width: "100%",
    },
    noViolationsText: (props) => ({
      margin: "0px",
      fontFamily: "Montserrat",
      fontSize: props.fontSize,
      color: props.textColorForNoViolations,
      // paddingLeft: '0.8em',
    }),
  };

const StripsofHumidity=(props)=>{
const {classes, params}=props;
// console.log('Params are', params.data)

const gettempValue=()=>{
    if (params.data.lastPing && params.data.lastPing.humidity && params.data.lastPing.humidity.length >= 1){
        return `${(params.data.lastPing.humidity[params.data.lastPing.humidity.length - 1] )} %`;
      }return ' - ';

}

// const getIcon=()=>{
//     const {violations, warnings}= params && params.data;
//     if(!violations && !warnings)return;
//    if(violations && warnings){
//     if(violations && violations.humidity > 0  ){
//         return (
//        <FontAwesomeIcon icon={faTint} style={{ color: 'rgb(255, 86, 48)', fontSize: '1.5em', alignContent:'left'}} />
//         )
//     }
//     if(warnings && warnings.humidity > 0){
//         return (
//             <FontAwesomeIcon icon={faTint} style={{ color: 'rgb(255, 171, 0)', fontSize: '1.5em', alignContent:'left' }} />
//         )
//     }
//    }
//    if(violations && !warnings){
//     if(violations && violations.humidity  ){
//         return(
//             <FontAwesomeIcon icon={faTint} style={{  color: 'rgb(255, 86, 48)', fontSize: '1.5em', alignContent:'left'}} />
//         )
//     }
//    }
//    if(!violations && warnings){
//     if(warnings && warnings.humidity ){
//         return(
//             <FontAwesomeIcon icon={faTint} style={{ color: 'rgb(255, 171, 0)', fontSize: '1.5em', alignContent:'left' }} />
//         )
//     }
//    }

// }

const getIcon=()=>{
  const {assetHumiditySettings }= params && params.data;
  if(!assetHumiditySettings )return;

let deviceStatus= "noVio";
const humidityLastPing=Number(params && params.data && params.data.lastPing && params.data.lastPing.humidity && params && params.data.lastPing.humidity[params && params.data.lastPing.humidity.length - 1] );
const maxVio= Number(assetHumiditySettings.maxViolation); 
const minVio= Number(assetHumiditySettings.minViolation); 
const maxWarning= Number(assetHumiditySettings.maxWarning); 
const minWarning= Number(assetHumiditySettings.minWarning); 
 
const isVio=humidityLastPing > maxVio
     || humidityLastPing < minVio

const isWarned = humidityLastPing > maxWarning 
     || humidityLastPing < minWarning
     if(isVio){
      deviceStatus ='Violation'
    }
    if(!isVio && isWarned){
      deviceStatus = 'Warning'
    }

    if( deviceStatus === 'Violation'){
      return (
        <FontAwesomeIcon icon={faTint} style={{ color: 'rgb(255, 86, 48)', fontSize: '1.5em', alignContent:'left'}} />
         )
    }
    if( deviceStatus === 'Warning'){
      return (
        <FontAwesomeIcon icon={faTint} style={{  color: 'rgb(255, 171, 0)', fontSize: '1.5em', alignContent:'left' }} />
         )
    }
    
}

const Icon= getIcon()

const tempValue=gettempValue()
return(
 
    <div>
         <div className={classes.outerDiv}>
         <div className={classes.modularDiv} >

         
            {Icon}
            <p className={classes.text}>
            {tempValue}
                </p>
          </div>
         </div>
    </div>



)


}


export default withStyles(styles)(StripsofHumidity);